import Vue from "vue"
import VeeValidate, {Validator} from "vee-validate"
import zh_CN from "vee-validate/dist/locale/zh_CN"

Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: "veeFields",
  errorBagName: "veeErrors",
  dictionary: {
    zh_CN: zh_CN
  }
})

// 自定义内置规则的错误信息
export const messages = {
  custom: {
    mobile: {
      required: () => '请输入手机号码!',
      mobile: () => '手机号码格式不正确!'
    },
    img_captcha: {
      required: () => '请输入图形验证码!'
    },
    sms_captcha: {
      required: () => '请输入短信验证码!',
      length: () => '短信验证码为6位数字!'
    },
    password: {
      required: () => '密码不得为空!',
      password: () => '至少包含1个英文字母和1个数字，不少于8-16个字符!'
    },
    selector: {
      required: () => '请选择一个选项!',
    },
    re_password: {
      required: () => '请再次输入密码!',
      confirmed: () => '两次密码输入不一致!'
    },
    id_card: {
      required: "身份证号码不得为空!"
    },
    birthday: {
      required: "请选择出生日期!",
      date_format: "出生日期有误!"
    },
    email: {
      required: () => "请输入电子邮箱!",
      email: () => "电子邮箱输入有误!"
    },
    age: {
      required: () => "请输入年龄!",
      between: () => "年龄必须在18-60岁之间!"
    }
  }
}

// 自定义校验规则
Validator.extend("mobile", {
  getMessage: field => "手机号码格式不正确",
  validate: value =>
    value.length === 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/.test(value)
})

Validator.extend("password", {
  getMessage: field => "至少包含1个英文字母和1个数字，不少于8-16个字符",
  validate: value => /^(?=.*[A-Za-z])(?=.*\d)[^]{8,16}$/.test(value)
})



// WEBPACK FOOTER //
// ./src/common/js/validator.js